import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = 'a417f9a545e9a0fef509fb5b7cadbe28';

mixpanel.init(MIXPANEL_TOKEN, {
  debug: true,
  persistence: 'localStorage',
});

export default mixpanel;
